import { render, staticRenderFns } from "./InsMenu.vue?vue&type=template&id=69b7b6c8&scoped=true&"
import script from "./InsMenu.vue?vue&type=script&lang=ts&"
export * from "./InsMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b7b6c8",
  null
  
)

export default component.exports